import type { ReactNode } from "react";
import { AuthBrand } from "@/app/components/auth/AuthBrand";
import { AuthShowcase } from "@/app/components/auth/AuthShowcase";

/**
 * Full-viewport split layout for login and signup — light form panel on the
 * left, dark product showcase on the right. Bypasses the mobile phone frame.
 */
export function AuthLayout({
  headline,
  subtitle,
  children,
}: Readonly<{
  headline: ReactNode;
  subtitle: string;
  children: ReactNode;
}>) {
  return (
    <div className="auth-layout">
      <div className="auth-panel-form">
        <div className="auth-form-inner">
          <AuthBrand />
          <h1 className="auth-headline">{headline}</h1>
          <p className="auth-subtitle">{subtitle}</p>
          {children}
        </div>
      </div>
      <AuthShowcase />
    </div>
  );
}
